import { render, staticRenderFns } from "./logoHead.vue?vue&type=template&id=504eafb8&"
import script from "./logoHead.vue?vue&type=script&lang=js&"
export * from "./logoHead.vue?vue&type=script&lang=js&"
import style0 from "./logoHead.vue?vue&type=style&index=0&id=504eafb8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports